<!-- Карточка чат-провайдера в разделе интеграций -->
<template>
  <BaseSettingsListItemCard
    :enabled="provider.enabled"
    :is-loading="isLoading"
    :show-edit="true"
    :show-toggle="true"
    :created-at="provider.created_at"
    :updated-at="provider.updated_at"
    :clickable="clickable"
    @edit="$emit('edit', provider)"
    @primary-action="$emit('primary-action', provider)"
    @toggle="$emit('toggle', provider)"
  >
    <template #actions>
      <base-button
        v-if="isMaxBot"
        class="chat-provider-card__check-button"
        :disabled="isLoading"
        @click="$emit('check-webhook', provider)"
      >
        {{ isLoading ? "Проверка..." : "Проверить подключение" }}
      </base-button>
    </template>

    <div class="chat-provider-card__top">
      <div class="chat-provider-card__heading">
        <h3 class="chat-provider-card__title">{{ provider.name }}</h3>
        <span class="chat-provider-card__description">
          {{ providerLabel }}
        </span>
      </div>
    </div>

    <a
      v-if="provider.bot_url"
      class="chat-provider-card__link"
      :href="provider.bot_url"
      target="_blank"
      rel="noopener noreferrer"
      @click.stop
    >
      Открыть бота
    </a>

    <template #details>
      <div class="chat-provider-card__details">
        <div class="chat-provider-card__detail">
          <span class="chat-provider-card__detail-label">Состояние webhook</span>
          <BaseInlineStatus
            :kind="provider.enabled ? 'success' : 'empty'"
            :text="provider.enabled ? 'Включен' : 'Отключен'"
          />
        </div>

        <div v-if="isMaxBot" class="chat-provider-card__detail">
          <span class="chat-provider-card__detail-label">Последняя успешная настройка</span>
          <time
            class="chat-provider-card__detail-value"
            :datetime="provider.webhook_subscribed_at"
          >
          {{ formatDateAndTimeLocal(provider.webhook_subscribed_at) }}
          </time>
        </div>
      </div>
    </template>
  </BaseSettingsListItemCard>
</template>

<script>
import { formatDateAndTimeLocal } from "@/utils/dateUtils";

const PROVIDER_LABELS = {
  max_bot: "Бот из мессенджера MAX",
  telegram_bot_client: "Telegram-бот",
};

export default {
  name: "ChatProviderCard",

  props: {
    provider: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["edit", "primary-action", "toggle", "check-webhook"],
  computed: {
    isMaxBot() {
      return this.provider.provider_type === "max_bot";
    },
    providerLabel() {
      return PROVIDER_LABELS[this.provider.provider_type] || "Чат-бот";
    },
  },
  methods: {
    formatDateAndTimeLocal,
  },
};
</script>

<style scoped>
.chat-provider-card__top {
  align-items: center;
  display: flex;
  gap: 12px;
  min-width: 0;
}

.chat-provider-card__heading {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.chat-provider-card__title {
  color: var(--color-dark);
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  word-break: break-word;
}

.chat-provider-card__description,
.chat-provider-card__detail-label {
  color: #777;
  font-size: 13px;
}

.chat-provider-card__details {
  border-top: 1px solid var(--color-border, #e5e7eb);
  display: grid;
  gap: 12px 24px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding-top: 14px;
}

.chat-provider-card__detail {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.chat-provider-card__detail :deep(.base-inline-status) {
  margin-top: 0;
  padding: 4px 8px;
  width: fit-content;
}

.chat-provider-card__detail-value {
  color: var(--color-dark);
  font-size: 14px;
  font-style: normal;
  line-height: 1.4;
}

.chat-provider-card__link {
  color: #057aff;
  display: inline-flex;
  font-size: 13px;
  margin-top: 8px;
  text-decoration: none;
}

.chat-provider-card__link:hover {
  text-decoration: underline;
}

.chat-provider-card__check-button {
  white-space: nowrap;
}

@media (max-width: 600px) {
  .chat-provider-card__details {
    grid-template-columns: 1fr;
  }
}
</style>
